module.exports = __webpack_public_path__ + "img/treat-2.e6068267.svg";